export default {
    'name': 'compare',
    'label': '123123123',
    'getComponent': () => import('./Compare.vue'),
    'tabIndex': 10,
    'left': false,
    'right': false,
    'singleView': false,
    'compareView': true,
    'exclusiveRoutePath': '/compare',
    'selfHandelPadding': true,
    'aclCheckKey': 'comparePatent',
};
